import { Component, EventEmitter, input, Input, Output, SimpleChanges } from '@angular/core';
import {
  RadioGroupOptions,
  ValueChangeEvent,
} from '@interfaces/form.interface';

@Component({
  selector: 'ark-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
})
export class RadioGroupComponent {
  @Input() selectedOwnership: string | null = null;
  _options: RadioGroupOptions = {
    name: '',
    items: [],
  };
  _selectedOwnership: RadioGroupOptions | null = null;

  @Input() set options(value: RadioGroupOptions) {
    this._options = value;
    // if any item is pre-checked, use that
    const preChecked = this._options.items.find(item => item.checked);
    if (preChecked) this.checkedValue = preChecked.value;
  }

  get options(): RadioGroupOptions {
    return this._options;
  }


  @Input() error = false;
  @Input() errorLabel = '';
  @Input() checkedValue: any = null;
  @Input() showInfoBubble = false;
  variant = input<'default' | 'ownership'>('default');

  @Output() valueChanged: EventEmitter<ValueChangeEvent> =
    new EventEmitter<ValueChangeEvent>();
  @Output() infoBubbleClicked: EventEmitter<any> = new EventEmitter<any>();
  

  // checkedValue: any = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedOwnership'] && this.selectedOwnership) {
      this.checkedValue = this.selectedOwnership;

      this.options.items.forEach(item => {
        item.checked = item.value === this.selectedOwnership;
      });
    }
  }


  selectOption(value: any): void {
    this.checkedValue = value;
    this.error = false;
    this.options.items.forEach(item => item.checked = item.value === value);
    this.valueChanged.emit({ value, status: 'VALID' });
  }

  onInfoBubbleClick(item: any) {
  this.infoBubbleClicked.emit(item);
}
}
